<template>
	<div class="adpot">
		<div class="group-content">
			<van-swipe-cell
				v-for="(item,ind) in adpotList"
				:key="ind">

					<van-cell title-class="van-cell-title">
						<template #title>
							过继 1/{{item.adpot}} 给 <span style="font-weight:bold;">{{family_name==item.psurname?'':item.psurname}}{{item.pname}}</span> 为 {{filterRelative(item.relative)}}
						</template>
					</van-cell>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditAdpot(item.id)" v-if="!readonly"/>
					<van-button square text="删除" type="danger" @click="onDelAdpot(item.id)" v-if="!readonly"/>
				</template>

			</van-swipe-cell>
			<div class="empty" v-if="adpotList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditAdpot" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px' }">
			<van-cell-group > 
				<van-field
					v-model="adpotInfo.adpot"
					type="digit"
					label="过继比： 1 / "
					required
					placeholder="请输入"
					clearable
				></van-field>
				<van-cell title="给：" title-class="van-field__label" required>
					<template #default>{{adpotInfo.pname}}</template>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="showAdpotLativePopup=true" :style="{'margin-left':'5px'}">选择被过继人</van-button></template>
				</van-cell>
				<van-cell title="为：" title-class="van-field__label" required>
					<template #default>{{filterRelative(adpotInfo.relative)}}</template>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="showPopup2AdpotRelative" :style="{'margin-left':'5px'}">选择</van-button></template>
				</van-cell>

				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="9">
						<van-button type="default" block  @click="showEditAdpot=false">取消</van-button>
					</van-col>
					<van-col span="1"></van-col>
					<van-col span="12">
						<van-button type="primary" block  @click="onSaveAdpot">保存</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 

			</van-cell-group>
		</van-popup>

		<van-popup v-model="showAdpotRelativePopup" position="bottom" :style="{'min-height':'200px', 'bottom':'50px'}">
			  <van-picker
				show-toolbar
				title="请选择"
				:columns="relativeArrs"
				@cancel="showAdpotRelativePopup = false"
				@confirm="onConfirmAdpotRelative"
			  />
		</van-popup>

		<van-popup v-model="showAdpotLativePopup" position="bottom" :style="{'min-height':'200px', 'max-height':'80%', 'bottom':'50px'}">
			<van-cell-group > 
				<van-field
					v-model.trim="relativeKey"
					label="名字："
					placeholder="请输入名字"
					clearable
				>
					<template #button>
						<van-button size="small" type="primary" @click="getPersonal2Adpot">查询</van-button>
					</template>
				</van-field>
			</van-cell-group>

			<div class="empty" v-if="relativeList.length==0">
				<span class="msg">{{relativeKey2==''?'请输入名字查询':('未查询到与 '+relativeKey2+' 相关人')}}</span>
			</div>

			<van-radio-group v-model="relativeRadioCheck">
				<van-cell-group inset>
					<van-cell title-class="van-cell-title" clickable @click="onRelativeRadioCheck(item)" :title="(family_name==item.surname?'':item.surname)+item.name" v-for="(item, ind) in relativeList" :key="ind">
						<template #right-icon>
							<van-radio :name="item.id" />
						</template>
					</van-cell>
				</van-cell-group>
			</van-radio-group>
 
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="22">
					<van-button type="primary" block  @click="showAdpotLativePopup=false">确定</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 
		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddAdpot" v-if="!readonly"/>

	</div>
</template>

<script>
import {Card, SwipeCell, Sidebar, SidebarItem, DatetimePicker } from "vant";
import { num2chinese } from "@/utils/common.js";

export default {
	name: "adpot",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"van-datetime-picker":DatetimePicker
	},
	props:{
		p_id:Number,
		family_name:String,
		pedigree_num:String,
		readonly:Boolean
	},
	data() {
		return {
			title: "过继关系管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

			adpotList:[],
			adpotInfoObj:{},
			showEditAdpot:false,
			adpotInfo:{},
			showAdpotRelativePopup:false,
			saveFlag:false,
			relativeKey:'',
			relativeKey2:'',
			showAdpotLativePopup:false,
			relativeRadioCheck:0,
			relativeList:[]
		};
	},
	created() {
		this.getAdpotData();
	},
	computed: {
		filterRelative(){
			return function(r){
				if(r==1){
					return '子';
				}
				if(r==2){
					return '孙';
				}
				if(r==3){
					return '曾孙';
				}
				return num2chinese(r)+'代孙';
			}
		},
		relativeArrs:function(){
			let zxArr = ['子','孙','曾孙'];
			for(var i=4;i<10;i++){
				zxArr.push(num2chinese(i)+'代孙')
			}
			return zxArr;
		}
	},
	methods: {
		getAdpotData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.p_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalAdpot" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.adpotList = [];
				that.adpotInfoObj = {};
				let edus = response.data.datas;
				if(edus && edus.length > 0){
					that.adpotList = edus;
					for(var i=0,il=edus.length; i<il; i++){
						that.adpotInfoObj[edus[i]['id']] = edus[i];
					};
				}
			})
			.catch(error => {});
		},
		showPopup2AdpotRelative(){
			this.showAdpotRelativePopup = true;
		},
		onAddAdpot(){
			this.adpotInfo = {c_id:this.p_id,adpot:2,relative:1};
			this.showEditAdpot = true;
		},
		onEditAdpot(id){
			this.adpotInfo = this.adpotInfoObj[id];
			this.showEditAdpot = true;
		},
		onDelAdpot(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/personalAdpotDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getAdpotData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		getPersonal2Adpot(){
			if(!this.relativeKey){
				this.$toast.fail("请输入查询名字！");
				return false;
			}
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.p_id,
				p_num:this.pedigree_num,
				relativeKey:this.relativeKey
			};
			this.relativeKey2 = this.relativeKey;
			this.relativeList = [];
			let that = this;
			var url = this.Conf.serverUrl + "clans/personal2Adpot" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 200){
					that.relativeList = response.data.datas;
				}else{
					that.$toast.success(response.data.msg);
				}
			})
			.catch(error => {});
		},
		onRelativeRadioCheck(item){
			this.relativeRadioCheck = item.id;
			this.adpotInfo.p_id = item.id;
			this.adpotInfo.pname = item.name;
			this.adpotInfo.psurname = item.surname;
		},
		onSaveAdpot(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.adpotInfo.adpot){
				this.$toast.fail("请输入过继比！");
				return false;
			}
			if(!this.adpotInfo.p_id){
				this.$toast.fail("请选择被过继人！");
				return false;
			}
			if(!this.adpotInfo.relative){
				this.$toast.fail("请选择过继关系！");
				return false;
			}
			this.saveFlag = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.adpotInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalAdpotSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getAdpotData();
					that.showAdpotRelativePopup = false;
					that.showEditAdpot = false;
				}
			})
			.catch(error => {});
		},
		onConfirmAdpotRelative(value, index){
			this.adpotInfo.relative = index+1;
			this.showAdpotRelativePopup=false;
			this.$forceUpdate();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/Adpot.vue